/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { userPoolDetailsGetResponseSchema } from './userPoolDetailsGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getUserPoolDetails200Schema = z.lazy(() => userPoolDetailsGetResponseSchema);

/**
 * @description 505 response
 */
export const getUserPoolDetails505Schema = z.any();

export const getUserPoolDetailsQueryResponseSchema = z.lazy(() => getUserPoolDetails200Schema);
